import * as React from "react";
import { Badge, mergeClasses } from "@fluentui/react-components";
import { ForboIcon } from "../../types/models";
import { toSecureIconUrl } from "../../utils/iconUrls";
import { useIconPickerStyles } from "./iconPickerStyles";

interface Props {
  icons: ForboIcon[];
  isInserting: boolean;
  selectedIcons: Set<string>;
  onToggleIcon: (iconId: string) => void;
}

const IconPickerGrid: React.FC<Props> = ({ icons, isInserting, selectedIcons, onToggleIcon }) => {
  const styles = useIconPickerStyles();

  return (
    <div className={styles.grid}>
      {icons.map((icon) => {
        const isSelected = selectedIcons.has(icon.id);

        return (
          <button
            key={icon.id}
            type="button"
            className={mergeClasses(
              styles.iconButton,
              isSelected && styles.iconButtonSelected,
              isInserting && styles.iconButtonDisabled
            )}
            disabled={isInserting}
            onClick={() => onToggleIcon(icon.id)}
          >
            <img
              className={styles.iconImage}
              title={icon.title}
              src={toSecureIconUrl(icon.icon)}
              width="88"
              height="88"
              alt={icon.title}
            />
            {isSelected ? (
              <Badge appearance="filled" color="informative" className={styles.selectionBadge}>
                OK
              </Badge>
            ) : null}
          </button>
        );
      })}
    </div>
  );
};

export default IconPickerGrid;
